import 'styles/index.css'
import 'react-toastify/dist/ReactToastify.css'
import 'styles/toast.css'

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import TaskAltIcon from '@mui/icons-material/TaskAlt'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { App } from 'App'
import { env } from 'app/env'
import { reportWebVitals } from 'app/report-web-vitals'
import { theme } from 'app/theme'
import { ErrorScreen } from 'components/common/error-screen'
import { AuthProvider } from 'hooks/use-auth'
import ReactDOM from 'react-dom/client'
import { ErrorBoundary } from 'react-error-boundary'
import { ToastContainer } from 'react-toastify'
import { ScrollToTop } from 'utils/scroll-to-top'

const setupWebVitals = (): void => {
  if (env.REACT_APP_REPORT_WEB_VITALS === 'on') {
    void reportWebVitals(console.log)
  }
}

setupWebVitals()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})

const root = ReactDOM.createRoot(document.querySelector('#root') as HTMLElement)

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <ErrorBoundary fallback={<ErrorScreen />}>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
        <ToastContainer
          closeButton={false}
          hideProgressBar
          icon={({ type }) =>
            type === 'success' ? (
              <TaskAltIcon
                sx={{ color: 'background.paper', fontSize: '22px' }}
              />
            ) : (
              <ErrorOutlineIcon
                sx={{ color: 'background.paper', fontSize: '22px' }}
              />
            )
          }
          position="bottom-right"
        />
        <ScrollToTop />
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  </ThemeProvider>,
)

if (env.REACT_APP_REPORT_WEB_VITALS === 'on') {
  reportWebVitals(console.log)
}
